(function () {
  var SELECTOR = '[data-hm-reveal]';
  var observer;

  function prefersReduced() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function inEditor() {
    return Boolean(window.Shopify && Shopify.designMode);
  }

  function revealAll(nodes) {
    nodes.forEach(function (el) {
      el.classList.add('is-in');
    });
  }

  function ensureObserver() {
    if (observer) return observer;
    observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.08, rootMargin: '0px 0px -6% 0px' }
    );
    return observer;
  }

  function bind(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var nodes = Array.prototype.slice.call(scope.querySelectorAll(SELECTOR));
    if (!nodes.length) return;

    if (prefersReduced() || inEditor()) {
      revealAll(nodes);
      return;
    }

    // Sin medir con getBoundingClientRect (forzaba un reflow al cargar): el IntersectionObserver
    // avisa en su primera pasada de los que ya están en pantalla.
    var io = ensureObserver();
    nodes.forEach(function (el) {
      io.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      bind(document);
    });
  } else {
    bind(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    bind(event.target);
  });
})();
